import apiClient from "../helper/Axios/axiosHelper";
import logger from "../utils/logger";


export class DeliveryService {


static async getStates() {

        
        const response= await apiClient.get(`/Delivery/States`)

        logger.warn('delivery states: ', response)

        return response
    



        
    }
}